const BEACON = 'bam.nr-data.net';

// Single entry point for New Relic. Callers use this rather than the vendor SDK directly.
class InstrumentationService {
    agent = null;

    ready = null;

    // The vendor package is imported dynamically: it probes native globals (setTimeout etc.)
    // at import time, which logs warnings under jsdom for any test that imports this module.
    init() {
        // Memoised so noticeError can safely call it: one load attempt, ever.
        if (!this.ready) this.ready = this.load();
        return this.ready;
    }

    load() {
        const {
            NEWRELIC_ENABLED,
            NEWRELIC_ACCOUNT_ID,
            NEWRELIC_TRUST_KEY,
            NEWRELIC_AGENT_ID,
            NEWRELIC_LICENSE_KEY,
            NEWRELIC_APPLICATION_ID,
        } = window.config;
        if (NEWRELIC_ENABLED !== true || !NEWRELIC_LICENSE_KEY || !NEWRELIC_APPLICATION_ID) return Promise.resolve();

        // eslint-disable-next-line import/no-unresolved -- eslint-import-resolver-node doesn't support package.json "exports" subpaths
        return import('@newrelic/browser-agent/loaders/browser-agent')
            .then(({ BrowserAgent }) => {
                this.agent = new BrowserAgent({
                    init: {
                        distributed_tracing: { enabled: false },
                        privacy: { cookies_enabled: true },
                        // Replay and traces can capture student data; keep off until reviewed.
                        session_replay: { enabled: false },
                        session_trace: { enabled: false },
                    },
                    info: {
                        beacon: BEACON,
                        errorBeacon: BEACON,
                        licenseKey: NEWRELIC_LICENSE_KEY,
                        applicationID: NEWRELIC_APPLICATION_ID,
                        sa: 1,
                    },
                    loader_config: {
                        accountID: NEWRELIC_ACCOUNT_ID,
                        trustKey: NEWRELIC_TRUST_KEY || NEWRELIC_ACCOUNT_ID,
                        agentID: NEWRELIC_AGENT_ID || NEWRELIC_APPLICATION_ID,
                        licenseKey: NEWRELIC_LICENSE_KEY,
                        applicationID: NEWRELIC_APPLICATION_ID,
                    },
                });
            })
            .catch(() => {
                // Monitoring is best-effort and must not break app boot.
            });
    }

    // The agent auto-captures uncaught errors and unhandled rejections; this is for caught ones.
    // Waits on init so errors raised while the agent is still loading aren't dropped.
    noticeError(error, customAttributes) {
        return this.init().then(() => this.agent?.noticeError(error, customAttributes));
    }
}

export default new InstrumentationService();
